<template>
  <div class="kbli-container">
    <div class="modal-company-kbli-wrapper">
      <div class="w-full flex-row">
        <div class="text-bold column5">No</div>
        <div class="text-bold column10">Kode</div>
        <div class="text-bold column40">Judul</div>
        <div class="text-bold column10">NIB</div>
        <div class="text-bold column10">SS Izin</div>
        <div class="text-bold column25">Izin Dokumen Lainnya</div>
      </div>
      <div
        class="w-full flex-row mt10"
        v-if="kbliData.length > 0"
        v-for="(list, index) in kbliData"
        :key="index"
      >
        <div class="column5">{{ index + 1 }}</div>
        <div class="column10">{{ list.kbli_sub.kode }}</div>
        <div class="column40">{{ list.kbli_sub.desc }}</div>
        <div class="column10">{{ list.nib ? 'Ada' : 'Tidak Ada' }}</div>
        <div class="column10">{{ list.ss_izin ? 'Ada' : 'Tidak Ada' }}</div>
        <div class="column25">
          {{ list.dokumen_lainnya ? 'Ada' : 'Tidak Ada' }}
        </div>
      </div>
    </div>

    <div class="kbli-mobile-container for-mobile">
      <div
        class="kbli-mobile-list"
        v-if="kbliData.length > 0"
        v-for="(list, index) in kbliData"
        :key="index"
      >
        <div class="w-full text-gray">Kode</div>
        <div class="w-full">{{ list.kbli_sub.kode }}</div>
        <div class="w-full text-gray">Kode</div>
        <div class="w-full">{{ list.kbli_sub.desc }}</div>
        <div class="w-full flex-row">
          <div class="text-gray column30">NIB</div>
          <div class="text-gray column30">SS Izin</div>
          <div class="text-gray column40">Izin Dokumen Lainnya</div>
        </div>
        <div class="w-full flex-row">
          <div class="column30">{{ list.nib ? 'Ada' : 'Tidak Ada' }}</div>
          <div class="column30">{{ list.ss_izin ? 'Ada' : 'Tidak Ada' }}</div>
          <div class="column40">
            {{ list.dokumen_lainnya ? 'Ada' : 'Tidak Ada' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    kbliData() {
      return this.$store.state.level1.kbliVendor
    },
  },
  created() {},
  methods: {},
}
</script>
